import { generalProfileActions, guestActions, locationActions, investmentsActions  } from '../actions';

export default function ui ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case generalProfileActions.SET_PROFILE: return generalUiReducer( newState, action );
        case generalProfileActions.GET_PROFILE_ERROR: return generalUiReducer( newState, action );
        case generalProfileActions.GET_PROFILE: return generalUiReducer( newState, action );
        case guestActions.SET_GUEST_MODE: return generalUiReducer( newState, action );
        case guestActions.TOGGLE_GUEST_MODE: return generalUiReducer( newState, action );
        // case locationActions.GENERAL_INDUSTRIES_ERROR: return generalUiReducer( newState, action );
        case investmentsActions.SET_INVESTMENTS_LIST: return generalUiReducer( newState, action );
        default: return newState;
    }
}

function generalUiReducer ( newState, action ) {

    delete action.type;
    return Object.assign( newState, { ...action } );
}



// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/ui.js